import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static counter = 0;

  connect() {
    this.tooltip = this.element.querySelector(".tooltiptext");
    if (!this.tooltip) return;

    if (!this.tooltip.id) {
      this.tooltip.id = `tooltip-${++this.constructor.counter}`;
    }
    this.tooltip.setAttribute("role", "tooltip");

    this.srOnly = document.createElement("span");
    this.srOnly.id = `${this.tooltip.id}-sr`;
    this.srOnly.className = "sr-only";
    this.srOnly.textContent = this.tooltip.textContent.trim();
    this.element.appendChild(this.srOnly);

    this.element.setAttribute("aria-describedby", this.srOnly.id);
  }

  disconnect() {
    if (this.tooltip?.parentNode === document.body) {
      document.body.removeChild(this.tooltip);
    }
    this.srOnly?.remove();
  }

  get isOpen() {
    return this.tooltip?.parentNode === document.body;
  }

  show() {
    if (!this.tooltip) return;

    document.body.appendChild(this.tooltip);

    this.tooltip.style.visibility = "hidden";
    this.tooltip.style.opacity = "0";
    this.tooltip.style.display = "block";
    this.tooltip.style.position = "fixed";
    this.tooltip.style.zIndex = "1000";

    const rect = this.element.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();

    const OFFSET = 4;
    const EDGE_MARGIN = 8;

    let top = rect.top - tooltipRect.height - OFFSET;
    if (top < EDGE_MARGIN) {
      top = rect.bottom + OFFSET;
    }

    let left = rect.right + OFFSET;

    if (left + tooltipRect.width > window.innerWidth - EDGE_MARGIN) {
      left = window.innerWidth - tooltipRect.width - EDGE_MARGIN;
    }

    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.left = `${left}px`;
    this.tooltip.style.transform = "none";

    this.tooltip.style.visibility = "visible";
    this.tooltip.style.opacity = "1";
  }

  hide() {
    if (!this.tooltip) return;

    this.tooltip.style.visibility = "hidden";
    this.tooltip.style.opacity = "0";

    this.element.appendChild(this.tooltip);
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      return this.isOpen ? this.hide() : this.show();
    }

    if (event.key === "Escape" && this.isOpen) {
      event.stopPropagation();
      this.hide();
    }
  }
}
